import React, { Component } from 'react'

import classNames from './ToggleForm.css'
import Icon from './Icon'

export default class ToggleForm extends Component {
  state = {
    open: this.props.initialOpen || false
  }
  toggleOpen = () => {
    const { open } = this.state
    this.setState({ open: !open })
  }
  shouldShowIndicator () {
    if (!this.props.indicatorValues) {
      return false
    }
    for (let value of this.props.indicatorValues) {
      if (value instanceof Array) {
        if (value.length !== 0) {
          return true
        }
      } else if (value) {
        return true
      }
    }
    return false
  }
  render () {
    const { showLabel, hideLabel, description, children } = this.props
    const { open } = this.state
    const showIndicator = this.shouldShowIndicator()
    return (
      <div className={open ? classNames.wrapperOpen : classNames.wrapper}>
        <button type='button' className={classNames.button} onClick={this.toggleOpen}>
          <Icon icon={open ? 'chevron-up' : 'chevron-down'} size={16} />
          <span> {open && hideLabel ? hideLabel : showLabel}</span>
          {showIndicator &&
            <span className={classNames.filledIndicator} />
          }
        </button>
        {open && description &&
          <div className={classNames.description}>{description}</div>
        }
        {open && children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ToggleForm.js